import React from "react"
import { graphql } from "gatsby"

import { Layout } from "../components/layout"
import { SEO } from "../components/seo"
import { Teaser } from "../components/teaser";
import { FluidObject } from "gatsby-image";

interface Props {
    data: {
        site: {
            siteMetadata: {
                title: string
            }
        },
        allMarkdownRemark: {
            edges: []
        }
    },
    location: Location
}

const IndexPage = ({ data, location }: Props) => {
    const siteTitle = data.site.siteMetadata.title
    const posts = data.allMarkdownRemark.edges

    return (
        <Layout location={location} title={siteTitle}>
            <SEO title="En minimalistisk resa" />

            <div className="max-w-2xl mx-auto">

                {posts.map(({ node }: {
                    node: {
                        excerpt: string,
                        timeToRead: number,
                        fields: {
                            slug: string
                        },
                        frontmatter: {
                            title: string,
                            description: string,
                            date: Date,
                            featuredImage: {
                                childImageSharp: {
                                    fluid: FluidObject
                                }
                            },
                            showFeaturedImage: boolean,
                            category: string,
                            published: boolean
                        }
                    }
                }) => {
                    const { title, date, featuredImage, showFeaturedImage = false, category: postCategory, published } = node.frontmatter
                    const { excerpt, timeToRead } = node
                    const { slug } = node.fields

                    const category = postCategory === null ? 'default' : postCategory

                    return (
                        <Teaser data={{
                            title,
                            excerpt,
                            timeToRead,
                            date,
                            slug,
                            category,
                            image: featuredImage,
                            showFeaturedImage,
                            published
                        }}
                            key={node.fields.slug}
                        />
                    )
                })}

            </div>
        </Layout>
    )
}

export default IndexPage


export const pageQuery = graphql`
  query IndexPageQuery($frontmatterFilterObj: MarkdownRemarkFrontmatterFilterInput){
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }, 
      filter: { frontmatter: $frontmatterFilterObj } 
    ) {
      edges {
        node {
          excerpt
          timeToRead
          fields {
            slug
          }
          frontmatter {
            date(formatString: "DD MMMM YYYY HH:ss")
            title
            description
            published
            category
            showFeaturedImage
            featuredImage {
              childImageSharp {
                  fluid(maxWidth: 768, maxHeight: 220) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
              }
            }
          }
        }
      }
    }
  }
`
